// START IMPORTS
import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { Stack } from '@ltvco/refresh-lib/theme';
import {
  FeatureBlockedModal,
  MonitoringOverview,
  useFeatureBlockedModal,
  useSriracha,
} from '@ltvco/refresh-lib/v2';
import { useState } from 'react';
// END IMPORTS

export function Monitoring() {
  // START HOOKS_AND_QUERIES
  const { data } = useSriracha();
  const {
    isFeatureBlockedModalOpen,
    closeFeatureBlockedModal,
    openFeatureBlockedModal,
  } = useFeatureBlockedModal();
  const { isBlocked, phoneOnlyVariation } =
    useSubscriptionAccessConfigContext();
  // END HOOKS_AND_QUERIES

  // START STATE_MANAGEMENT
  const [searchType, setSearchType] = useState('');
  const [paymentShowModalNumber, setPaymentShowModalNumber] =
    useState<number>(0);
  // END STATE_MANAGEMENT

  // START DERIVED_DATA_AND_UTILS
  const notifications = data || [];

  const peopleSearchBlocked = isBlocked('person');
  const customCTAPublishEvent = phoneOnlyVariation
    ? 'openPhoneSearch'
    : undefined;
  // END DERIVED_DATA_AND_UTILS

  // START EVENT_HANDLERS
  const onClickHandler = () => {
    if (peopleSearchBlocked) {
      setSearchType('People');
      openFeatureBlockedModal();
    }
  };
  // END EVENT_HANDLERS

  // START RENDER
  return (
    <Stack p={{ xs: 2, sm: 0 }}>
      <MonitoringOverview
        notifications={notifications}
        onClickHandler={onClickHandler}
        searchBlocked={peopleSearchBlocked}
        customCTAPublishEvent={customCTAPublishEvent}
      />
      <FeatureBlockedModal
        isOpen={isFeatureBlockedModalOpen}
        onClose={closeFeatureBlockedModal}
        searchType={searchType}
        paymentShowModalNumber={paymentShowModalNumber}
        setPaymentShowModalNumber={setPaymentShowModalNumber}
      />
    </Stack>
  );
  // END RENDER
}
